module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "move"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlag),
      expression: "showFlag"
    }],
    ref: "food",
    staticClass: "food"
  }, [_c('div', {
    staticClass: "food-content"
  }, [_c('div', {
    staticClass: "image-header"
  }, [_c('img', {
    attrs: {
      "src": _vm.food.image,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "back",
    on: {
      "click": _vm.hide
    }
  }, [_c('i', {
    staticClass: "icon-arrow_lift icon-font"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.food.name))]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('span', {
    staticClass: "sell-count"
  }, [_vm._v("月售" + _vm._s(_vm.food.sellCount) + "份")]), _vm._v(" "), _c('span', {
    staticClass: "rating"
  }, [_vm._v("好评率" + _vm._s(_vm.food.rating) + "%")])]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_c('span', {
    staticClass: "now"
  }, [_vm._v("￥" + _vm._s(_vm.food.price))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.food.oldPrice),
      expression: "food.oldPrice"
    }],
    staticClass: "old"
  }, [_vm._v("￥" + _vm._s(_vm.food.oldPrice))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.food.count > 0),
      expression: "food.count>0"
    }],
    staticClass: "cartcontrol-wrapper"
  }, [_c('cartcontrol', {
    attrs: {
      "food": _vm.food
    },
    on: {
      "add": _vm.addFood
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.food.count || _vm.food.count === 0),
      expression: "!food.count||food.count===0"
    }],
    staticClass: "buy",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.addFirst($event)
      }
    }
  }, [_vm._v("加入购物车")])])], 1), _vm._v(" "), _c('split', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.food.info),
      expression: "food.info"
    }]
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.food.info),
      expression: "food.info"
    }],
    staticClass: "info"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("商品信息")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.food.info))])]), _vm._v(" "), _c('split'), _vm._v(" "), _c('div', {
    staticClass: "rating"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("商品评价")]), _vm._v(" "), _c('ratingselect', {
    attrs: {
      "selectType": _vm.selectType,
      "onlyContent": _vm.onlyContent,
      "desc": _vm.desc,
      "ratings": _vm.food.ratings
    },
    on: {
      "select": _vm.selectRating,
      "onlyContent": _vm.toggleContent
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "rating-wrapper"
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.food.ratings && _vm.food.ratings.length),
      expression: "food.ratings && food.ratings.length"
    }]
  }, _vm._l((_vm.food.ratings), function(rating) {
    return (_vm.needShow(rating.rateType, rating.text)) ? _c('li', {
      staticClass: "rating-item border-1px"
    }, [_c('div', {
      staticClass: "user"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(rating.username))]), _vm._v(" "), _c('img', {
      staticClass: "avatar",
      attrs: {
        "width": "12",
        "height": "12",
        "src": rating.avatar,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(rating.rateTime)))]), _vm._v(" "), _c('p', {
      staticClass: "text"
    }, [_c('i', {
      staticClass: "icon-font",
      class: {
        'icon-thumb_up': rating.rateType === 1, 'icon-thumb_down': rating.rateType === -1
      }
    }), _vm._v("\n                " + _vm._s(rating.text) + "\n              ")])]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.food.ratings || !_vm.food.ratings.length),
      expression: "!food.ratings||!food.ratings.length"
    }],
    staticClass: "no-rating"
  }, [_vm._v("\n            暂无评价\n          ")])])], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-729cba86","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/food/food.vue
// module id = 54
// module chunks = 0